module.exports = __webpack_public_path__ + "campfire-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/campfire-logo.png
// module id = 1252
// module chunks = 74